import { render, staticRenderFns } from "./_Logo.vue?vue&type=template&id=60c41e61&"
import script from "./_Logo.vue?vue&type=script&lang=js&"
export * from "./_Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports